import { z } from "zod"

export const BackofficeClusterKeySchema = z.object({
  key: z.string(),
  companyId: z.bigint().transform(String),
  domain: z.string(),
  goalId: z
    .bigint()
    .nullish()
    .transform((v) => (v ? String(v) : null)),
  campaignId: z
    .bigint()
    .nullish()
    .transform((v) => (v ? String(v) : null)),
  from: z.date(),
  to: z.date(),
  epsilon: z.string().nullish(),
  samplingFactor: z.string().nullish(),
  selectionMethod: z.string().nullish(),
  biasFilter: z.string().nullish(),
  score: z.int().min(0).max(3).default(0),
})

export const BackofficeGetClustersKeysResponseDataSchema = z.array(BackofficeClusterKeySchema)

const ClusterItemSchema = z.object({
  label: z.string().nullish(),
  description: z.string().nullish(),
  itemsCount: z.number().nullish(),
  customersCount: z.number().nullish(),
  conversationsCount: z.number().nullish(),
  overallSentiment: z.number().nullable().nullish(),
  overallSolveRate: z.number().nullable().nullish(),
  potentialSolveRate: z.number().nullable().nullish(),
  items: z.array(
    z.object({
      id: z.union([z.string(), z.number()]).transform(String),
      conversationId: z.union([z.string(), z.number()]).transform(String).optional(),
      text: z.string(),
      sentiment: z.number().optional().nullable(),
      autoSolved: z.boolean().optional().nullable(),
      couldBeAutoSolved: z.boolean().optional().nullable(),
      isAnswered: z.boolean().optional().nullable(),
      isKnowledgeGap: z.boolean().optional().nullable(),
      eligibility: z.enum(["Unknown", "Eligible", "NotEligible"]).optional().nullable(),
      status: z.enum(["Pending", "Fulfilled", "Dismissed"]).optional().nullable(),
      urgency: z.enum(["Low", "Medium", "High"]).optional().nullable(),
    }),
  ),
})

export const BackofficeGetClusterResponseDataSchema = z.array(ClusterItemSchema)

export const ClusterDataWithScoreSchema = z.object({
  clusters: BackofficeGetClusterResponseDataSchema,
  score: z.int().min(0).max(3).default(0),
})

export const BackofficeGenerateClusterResponseDataSchema = z.object({
  success: z.boolean(),
})

export const BackofficeDeleteClustersResponseDataSchema = z.object({
  deleted: z.int().nonnegative(),
})
